<template>
  <el-dialog
    title="能耗计划设置"
    :visible.sync="dialogVisible"
    width="65%"
    :before-close="beforeClose"
  >
    <div class="" style="height:60vh">
      <div class="date row-center" style="justify-content:space-between;">
        <div class="month">
          <span v-for="item in month" :class="{active:active==item}" @click="active=item">{{ item }}月</span>
        </div>
        <div class="row-center">
          <div class="clear" @click="clearPlan()">清空本月计划</div>
          <el-button type="primary" class="btn" @click="seavePlan()">保存</el-button>
        </div>
      </div>
      <tree-table
        class="tb-cate"
        :data="planlist"
        :is-fold="false"
        :columns="columns"
        :expand-type="false"
        :selection-type="false"
      >
        <template slot="electric" slot-scope="scope">
          <el-input
            v-model="scope.row.electric"
            placeholder="未设置"
            class="einput"
            @blur.prevent="changeData(scope.row,'electric')"
          ></el-input>
        </template>
        <template slot="water" slot-scope="scope">
          <el-input
            v-model="scope.row.water"
            placeholder="未设置"
            class="einput"
            @blur.prevent="changeData(scope.row,'water')"
          ></el-input>
        </template>
        <template slot="heat" slot-scope="scope">
          <el-input
            v-model="scope.row.heat"
            placeholder="未设置"
            class="einput"
            @blur.prevent="changeData(scope.row,'heat')"
          ></el-input>
        </template>
        <template slot="cooling" slot-scope="scope">
          <el-input
            v-model="scope.row.cooling"
            placeholder="未设置"
            class="einput"
            @blur.prevent="changeData(scope.row,'cooling')"
          ></el-input>
        </template>
      </tree-table>
      <div class="pagination">
          <el-button :disabled="pageno==1" @click="pageIndex">首页</el-button>
          <el-button :disabled="pageno==1" @click="pagePerv">上一页</el-button>
          <span class="size">{{pageno}}/{{pageTotal}}</span>
          <el-button :disabled="pageno>=pageTotal" @click="pageNext">下一页</el-button>
          <el-button :disabled="pageno>=pageTotal" @click="pageLast">尾页</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { treeBuilding } from "../../api/common";
import { conservationPlan,listSaveOrUpdate } from "../../api/power";
import {
  dateFormat,
} from "../../util/DateUtil";
export default {
  props: {
    dialogVisible: Boolean,
  },
  data() {
    return {
      month: [],
      active:new Date().getMonth()+1,
      columns: [
        { label: "区域", prop: "name",width:"280px" },
        {
          label: "用电限额（kWh）",
          prop: "electric",
          type: "template",
          template: "electric",
        },
        {
          label: "用水限额（m³）",
          prop: "water",
          type: "template",
          template: "water",
        },
        {
          label: "用热限额（GJ）",
          prop: "heat",
          type: "template",
          template: "heat",
        },
        {
          label: "用冷限额（GJ）",
          prop: "cooling",
          type: "template",
          template: "cooling",
        },
      ],
      tree:[],//填充数据
      pageno:1,
      pageSize:8,
      filterArray:[],
    };
  },
  watch:{
    active(){
      this.GetreeBuilding();
    }
  },
  computed:{
    planlist(){
      const list = this.filterArray.map(e=>{ e.children=[]; return e})
      if(this.tree.length>0){
        this.tree.forEach(elm=>{
          list.forEach(item=>{
            if(elm.buildingId){
              // if(item.children.length>0){
              //   item.children.forEach(child=>{
              //     if(elm.buildingId==child.id){
              //       child.cooling = elm.cooling
              //       child.electric = elm.electric
              //       child.water = elm.electric
              //       child.heat = elm.heat
              //     }
              //   })
              // }
              if(elm.buildingId==item.id){
                item.cooling = elm.cooling?elm.cooling:""
                item.electric = elm.electric?elm.electric:""
                item.water = elm.water?elm.water:""
                item.heat = elm.heat?elm.heat:""
              }
            }else{
                this.filterArray[0].cooling = elm.cooling?elm.cooling:""
                this.filterArray[0].electric = elm.electric?elm.electric:""
                this.filterArray[0].water = elm.water?elm.water:""
                this.filterArray[0].heat = elm.heat?elm.heat:""
            }
          })
        })
      }else{
        list.forEach(item=>{
            item.cooling = ""
            item.electric = ""
            item.water = ""
            item.heat = ""
        })
      }
      const data = this.arrToTree(list.slice((this.pageno-1)*8,this.pageno*8))
      return data
    },
    pageTotal(){
      return  Math.ceil(this.filterArray.length/8) 
    }
  },
  mounted() {
    for (let index = 1; index <= 12; index++) {
      this.month.push(index);
    }
    this.GetreeBuilding();
  },
  methods: {
    pageNext(){
      this.pageno++
    },
    pageLast(){
      this.pageno = this.pageTotal
    },
    pagePerv(){
      this.pageno--
    },
    pageIndex(){
      this.pageno = 1
    },
    //修改文本框数据
    changeData(obj,val){
      this.filterArray.forEach(item=>{
        if(item.id==obj.id){
          item[val] = obj[val]
        }
      })
    },
    //保存
    seavePlan(){
      let list = []
      this.filterArray.forEach(item=>{
          list.push({
            buildingId:item.id,
            "cooling":item.cooling?item.cooling:'',
            "electric": item.electric?item.electric:'',
            "heat": item.heat?item.heat:'',
            "water": item.water?item.water:'',
            "month": this.active,
            "projectId": this.$store.state.project.currentProject.projectId,
            "year": dateFormat("YY", new Date())
          })
      })
      let obj = {
        conservationPlanList:list
      }
      listSaveOrUpdate(obj).then((res) => {
        if(res.data.data.result){
          this.$message({
            message: '提交成功！',
            type: 'success'
          });
        }else{
          this.$message.error('提交失败！');
        }
      });
    },
    //数组转树状
    arrToTree(arr) {
      let obj = []
      for (let i in arr) {
        if (!arr[i].parentId) {
          obj.push(arr[i])
        } else {
          let item = arr.find(element => element.id === arr[i].parentId)
          if(item){
            item.children.push(arr[i])
          }else{
            obj.push(arr[i])
          }
          
        }
      }
      return obj
    },
    //树状转数组
    treeToArr(data) {
      const result = [];
      data.forEach(item => {
          const loop = data => {
              result.push(data);
              let child = data.children
              if(child.length>0){
                for(let i = 0; i < child.length; i++){
                  loop(child[i])
                }
              }
          }
          loop(item);
      })
      return result;
    },
    //清空计划
    clearPlan(){
      this.tree = []
    },
    GetTreeData(){
      let obj = {
        month:this.active,
        projectId:this.$store.state.project.currentProject.projectId,
        year:new Date().getFullYear()
      }
      conservationPlan(obj).then((res) => {
        this.tree = res.data.data.list;
      });
    },
    //楼栋
    GetreeBuilding() {
      treeBuilding().then((res) => {
        let loops = res.data.data.tree;
        //loops.unshift({
        //  name:"全部",
         // id:0,
        //  children:[],
        //  parentId:0
       // });
        // this.loops = loops
        let list = this.treeToArr(loops)
        this.filterArray = list
        this.GetTreeData();
      });
    },
    beforeClose() {
      this.$emit("handleClose", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.zk-table__cell-inner{
  padding-left: 20px !important;
}
.pagination{
    text-align: center;
    padding: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
    .el-button{
            padding: 8px 20px;
    }
    .size{
        width: 100px;
        display: inline-block;
    }
}
/deep/.zk-icon-minus-square-o{
    background: url('../../assets/img/ardown.png') center no-repeat;
    width: 12px;
    height: 7px;
    display: inline-block;
    &::before{
        content: none !important;
    }
}
/deep/.zk-icon-plus-square-o{
    background: url('../../assets/img/aright.png') center no-repeat;
    width: 12px;
    height: 12px;
    display: inline-block;
    &::before{
        content: none !important;
    }
}
/deep/.el-dialog__body {
  padding: 0 !important;
}
.date {
  padding: 20rem;
  .month {
    span {
      width: 64rem;
      height: 36rem;
      background: rgba(0, 43, 102, 0.06);
      border-radius: 4rem;
      display: inline-block;
      text-align: center;
      line-height: 36rem;
      margin-right: 5rem;
      font-size: 18rem;
      cursor: pointer;
    }
    .active{
        background: #0D94FF;
        color:#fff
    }
  }
  .clear{
      border: 1px solid #CCCCCC;
        border-radius: 4rem;
        color: #666666;
        height: 36rem;
        font-size: 16rem;
        cursor: pointer;
        line-height: 36rem;
        padding: 0 10px;
  }

  .btn{
    height: 32px;
    width: 66px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    margin-left: 10px;
  }
}
/deep/.tb-cate {
  border-collapse: collapse;
  text-align: center;
  width: 100%;
  th {
    background: rgba(0, 43, 102, 0.06);
    font-size: 18rem;
    font-weight: bold;
    height: 4vh;
    text-align: center !important;
  }
  td {
    font-size: 18rem;
    height: 5vh;
    .el-input__inner {
      width: 100%;
      height: 3vh;
      text-align: center;
      color: #0d94ff;
    }
  }
}
</style>
